import React from "react";
import ModalContainer from "./ModalContainer";
import VideoList from "./VideoList";

export default function VideoModal(props){

    return (
        <ModalContainer>
            <div className={props.modalState ? 'openModal modal' : 'modal'}>
                {props.modalState ? (
                    <section>
                        <header>
                            {"경기 영상 플레이어"}
                            <button className="close" onClick={props.closeModal}>
                                &times;
                            </button>
                        </header>
                        <main>
                            <VideoList parameterSet={props.parameterSet} content={props.content} />
                        </main>
                        <footer>
                            <button className="close" onClick={props.closeModal}>
                                close
                            </button>
                        </footer>
                    </section>
                ) : null}
            </div>
        </ModalContainer>
    )
}